export default __webpack_public_path__ + "static/char-s-31-zh-Hans-53e562cf1add3e0f90cdcabc426a1cb1.webp";